export default function GS_Location_Settings() {
  return (
    <div className="p-4">
      <h1>GS Location Settings</h1>
    </div>
  );
}
